import { Avatar } from '@assembly-js/design-system';

import { getInitials } from 'src/utils/UserUtils';

/**
 * This component renders an avatar with a description.
 * We use this in several places that renders user avatar with
 * a name and email. e.g. forms responses table, user cell renderer, etc.
 * @param showAvatar - whether to show the avatar
 * @param src - the source of the avatar
 * @param fallbackColor - the fallback color of the avatar
 * @param email - the email of the user
 * @param name - the name of the user
 * @returns {JSX.Element} - the avatar with description
 */
export const AvatarWithDescription = ({
  showAvatar = true,
  src,
  fallbackColor,
  email,
  name,
}: {
  src: string;
  fallbackColor: string;
  name: string;
  email?: string;
  showAvatar?: boolean;
}) => {
  return (
    <div className="flex gap-3 items-center">
      {showAvatar && (
        <Avatar
          src={src}
          fallbackColor={fallbackColor}
          variant="circle"
          text={getInitials(name, {
            twoLetters: true,
          })}
          size="md"
          alt={name}
        />
      )}
      <div className="flex flex-col gap-1">
        <span className="text-[12px] text-primary">{name}</span>
        {email && <span className="text-[12px] text-secondary">{email}</span>}
      </div>
    </div>
  );
};
